<template>
	<Row class="activator-container flex-centerize">
		<AppLoader class="flex-centerize" v-if="isLoading" />
		<template v-else>
			<h3 v-if="showStateInActivator" class="status reg mr-2">{{ status }}</h3>
			<SIcon :name="iconName" width="20" height="20" />
			<v-icon class="ml-1" :class="{ rotate: isOpen }" color="#64666A" size="16">mdi-chevron-down</v-icon>
		</template>
	</Row>
</template>

<script>
export default {
	name: 'FeatureVisibilityActivator',
	props: {
		isOpen: { type: Boolean },
		isLocked: { type: Boolean },
		disabled: { type: Boolean },
		isVisible: { type: Boolean },
		isLoading: { type: Boolean },
		showStateInActivator: { type: Boolean },
	},
	computed: {
		iconName() {
			if (this.disabled || this.isLocked) {
				return this.lockedVisibleIconName;
			}
			return this.isVisible ? this.visibleIconName : this.hiddenIconName;
		},
		status() {
			if (this.isLocked) {
				return 'Visible - locked';
			}
			return this.isVisible ? 'Visible' : 'Hidden';
		},
	},
	data() {
		return {
			hiddenIconName: 'visibility-hidden',
			visibleIconName: 'visibility-visible',
			lockedVisibleIconName: 'visibility-visible-locked',
		};
	},
};
</script>

<style lang="scss" scoped>
.activator-container {
	height: 25px;
	min-width: 54px;
	padding: 0px 6px;
	border-radius: 6px;
	background: var(--white);
	border: 1px solid #d6ddea;
}
.rotate {
	transform: rotate(-180deg);
	transition: var(--transition-time);
}
.status {
	opacity: 0.5;
	color: #292829;
}
</style>
